import { createContext, useContext } from 'react';
import { HospitalSchedule } from '../ScheduleTypes';

const ScheduleContext = createContext<{
  hospitalSchedule: HospitalSchedule;
  hospitalDispatch: React.Dispatch<{ type: string; payload: any }>;
}>({
  hospitalSchedule: {} as HospitalSchedule,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  hospitalDispatch: () => {},
});

const useSchedule = () => {
  const context = useContext(ScheduleContext);
  if (context === undefined) {
    throw new Error('useSchedule must be used within a ScheduleProvider');
  }
  return context;
};

export { ScheduleContext, useSchedule };
